'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.MittelgeberSchema = {
  title: 'Mittelgeber',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/mittelgeber.js
// module id = nRdA
// module chunks = 0